import { makeDoubleArgHook } from "../../utils/makeDoubleArgHook";
import { stringifyQueryParams, } from "../request/getPortfolioPlanById";
import { getPortfolioPlanByIdPublic, portfolioPlanByIdPublicURL, } from "../request/getPortfolioPlanByIdPublic";
import { ALL_PORTFOLIOS } from "./constants";
export function portfolioPlanByIdPublicKeyMaker(portfolioPlanId, params) {
    if (params === null) {
        return [
            portfolioPlanByIdPublicURL(ALL_PORTFOLIOS),
            portfolioPlanByIdPublicURL(portfolioPlanId),
        ];
    }
    return [
        portfolioPlanByIdPublicURL(ALL_PORTFOLIOS),
        portfolioPlanByIdPublicURL(portfolioPlanId),
        stringifyQueryParams(params),
    ];
}
// CAUTION: this is a "public" hook to an endpoint that does not require Oso (person fetching is authorized to get/see the portfolio)
// the only security is basic authentication via the token that is passed in the header
const useGetPortfolioPlanByIdPublic = makeDoubleArgHook(getPortfolioPlanByIdPublic, (portfolioId, params) => portfolioPlanByIdPublicKeyMaker(portfolioId, params));
export default useGetPortfolioPlanByIdPublic;
//# sourceMappingURL=useGetPortfolioPlanByIdPublic.js.map